/**
 * @desc 获取businessKey
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.warehouseCost.getBusinessKey.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouseCost/getBusinessKey`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
